module.exports = __webpack_public_path__ + "static/media/changeScale2.cd71afac.gif";